module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12 financial-physical-schedule"
  }, [_c('fieldset', [_c('table', {
    staticClass: "table table-condensed table-bordered",
    attrs: {
      "align": "center"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Parcela")]), _vm._v(" "), _c('th', [_vm._v("Recurso")]), _vm._v(" "), _c('th', [_vm._v("Fase")]), _vm._v(" "), _c('th', [_vm._v("Valor total por fase")]), _vm._v(" "), _c('th', [_vm._v("Valor a solicitar por fase")]), _vm._v(" "), _c('th', [_vm._v("Saldo restante por fase")]), _vm._v(" "), (_vm.propsFase === 'Análise Financeira') ? _c('th', [_vm._v("Número título")]) : _vm._e(), _vm._v(" "), (_vm.propsFase === 'Análise Financeira') ? _c('th', [_vm._v("Conta Financeira")]) : _vm._e(), _vm._v(" "), (_vm.propsFase !== 'Análise Financeira') ? _c('th', [_vm._v("Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itens), function(item) {
    return _c('tr', {
      attrs: {
        "disabled": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(item.parcelas_adiantamentos[0].parcela))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rotuloOrigemParcela(item.parcelas_adiantamentos[0].origem)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.parcelas_adiantamentos[0].origem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(item.parcelas_adiantamentos[0].valor)))]), _vm._v(" "), (item.editando === false || !item.editando) ? _c('td', [_vm._v(_vm._s(_vm._f("real")(item.valor ? item.valor : 0)))]) : _vm._e(), _vm._v(" "), (item.editando === true) ? _c('td', {
      staticClass: "text-center"
    }, [_c('money', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control text-right",
      class: {
        'has-error': _vm.errors.first('valor')
      },
      attrs: {
        "name": "valor",
        "type": "text",
        "disabled": item.totalValueRequested > 0 || !_vm.propsEnable
      },
      model: {
        value: (item.valor),
        callback: function($$v) {
          _vm.$set(item, "valor", $$v)
        },
        expression: "item.valor"
      }
    })], 1) : _vm._e(), _c('td', [_vm._v(_vm._s(_vm._f("real")(item.parcelas_adiantamentos[0].valor - (item.valor ? item.valor : 0))))]), _vm._v(" "), (_vm.propsFase === 'Análise Financeira') ? _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "input-group",
      class: {
        'has-error': _vm.errors.first('Número título')
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.numeroTitulo),
        expression: "item.numeroTitulo"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control text-right",
      attrs: {
        "type": "number",
        "name": "Número título"
      },
      domProps: {
        "value": (item.numeroTitulo)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "numeroTitulo", $event.target.value)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.propsFase === 'Análise Financeira') ? _c('td', {
      staticClass: "text-right form-group required-field"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.contaFinanceira),
        expression: "item.contaFinanceira"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      class: {
        'has-error': _vm.errors.first('conta financeira')
      },
      attrs: {
        "name": "conta financeira",
        "aria-hidden": "true"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "contaFinanceira", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.contasFinanceiras), function(conta) {
      return _c('option', {
        domProps: {
          "value": conta.ctared
        }
      }, [_vm._v(_vm._s(conta.ctared) + " / " + _vm._s(conta.descta))])
    }), 0)]) : _vm._e(), _vm._v(" "), (_vm.propsFase !== 'Análise Financeira') ? _c('td', {
      staticClass: "text-center"
    }, [(!item.editando && _vm.propsEnable) ? _c('i', {
      staticClass: "fa fa-edit",
      staticStyle: {
        "margin-left": "5px"
      },
      on: {
        "click": function($event) {
          return _vm.editItem(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.editando) ? _c('i', {
      staticClass: "fa fa-check",
      staticStyle: {
        "color": "green",
        "margin-left": "5px"
      },
      on: {
        "click": function($event) {
          return _vm.editItem(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.editando) ? _c('i', {
      staticClass: "fa fa-times",
      staticStyle: {
        "color": "red",
        "margin-left": "5px"
      },
      on: {
        "click": function($event) {
          return _vm.cancelaEdicao(item)
        }
      }
    }) : _vm._e()]) : _vm._e()])
  }), 0), _vm._v(" "), _c('tfoot', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('tr', {
    directives: [{
      name: "default",
      rawName: "v-default",
      value: (_vm.atualizaCalculoGrid(_vm.item)),
      expression: "atualizaCalculoGrid(item)"
    }]
  }, [_c('td', {
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Total valor solicitado:\t")]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.valorTotalSolicitacao)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Valor disponível para solicitação nesta parcela:\t")]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.valorTotalDisponivel - _vm.valorTotalSolicitacao)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Valor total liberado para solicitação:\t")]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.valorTotalDisponivel)))])])])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Parcelas Adiantáveis")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b2d2d90!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/validação/solicitacoes/adiantamento/componentes/cronograma-solicitacao-adiantamento-validacao.vue
// module id = 1918
// module chunks = 1